/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PendingEnrollmentRow } from './PendingEnrollmentRow';
import {
    PendingEnrollmentRowFromJSON,
    PendingEnrollmentRowFromJSONTyped,
    PendingEnrollmentRowToJSON,
    PendingEnrollmentRowToJSONTyped,
} from './PendingEnrollmentRow';

/**
 * 
 * @export
 * @interface RecentPendingEnrollmentsWidgetData
 */
export interface RecentPendingEnrollmentsWidgetData {
    /**
     * 
     * @type {Array<PendingEnrollmentRow>}
     * @memberof RecentPendingEnrollmentsWidgetData
     */
    items: Array<PendingEnrollmentRow>;
}

/**
 * Check if a given object implements the RecentPendingEnrollmentsWidgetData interface.
 */
export function instanceOfRecentPendingEnrollmentsWidgetData(value: object): value is RecentPendingEnrollmentsWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function RecentPendingEnrollmentsWidgetDataFromJSON(json: any): RecentPendingEnrollmentsWidgetData {
    return RecentPendingEnrollmentsWidgetDataFromJSONTyped(json, false);
}

export function RecentPendingEnrollmentsWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecentPendingEnrollmentsWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(PendingEnrollmentRowFromJSON)),
    };
}

export function RecentPendingEnrollmentsWidgetDataToJSON(json: any): RecentPendingEnrollmentsWidgetData {
    return RecentPendingEnrollmentsWidgetDataToJSONTyped(json, false);
}

export function RecentPendingEnrollmentsWidgetDataToJSONTyped(value?: RecentPendingEnrollmentsWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(PendingEnrollmentRowToJSON)),
    };
}

